<template src="./FareAddEdit.html">

</template>

<script>
import {
  getRoute,
  postRoute,
  putRoute,
  upsertRouteSection
} from '@/services/routes'

import { getLocations } from '@/services/location'

const travelDays = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT']

export default {
  name: 'FareAddEdit',
  props: ['id'],
  data () {
    return {
      locations: [],
      travelDays: travelDays,
      non_travel_days: [],
      model: {
        amount: null,
        discount: '',
        from_loc: null,
        to_loc: null,
        description: null,
        sections: [],
        non_travel_days: [],
        is_charter: false,
        offline_amount: 0,
        blocked: false
      },
      isEditing: false
    }
  },

  computed: {
    showSection () {
      return this.model.id !== undefined
    }
  },

  created () {
    this.onGetLocations()
  },

  mounted () {
    const id = this.$route.params.id
    if (id) {
      this.findRoute(id)
    }
  },

  methods: {
    onAddSection () {
      // get the last index
      let nextKey = 1
      if (this.model.sections.length !== 0) {
        const lastItem = this.model.sections[this.model.sections.length - 1]
        nextKey = lastItem.key + 1
      }
      this.model.sections.push({
        key: nextKey,
        section: 'New section'
      })
    },

    findRoute (id) {
      getRoute(id)
        .then((res) => {
          this.model = res.data
          this.model.from_loc = this.model.from_loc.id
          this.model.to_loc = this.model.to_loc.id
          if (!res.data.sections) {
            this.model.sections = []
          }
          if (this.model.non_travel_days) {
            this.non_travel_days = this.model.non_travel_days.split(',')
          }
          this.isEditing = true
        })
    },

    handleSaveFare () {
      const httpRequest = this.isEditing ? putRoute : postRoute
      this.model.non_travel_days = this.non_travel_days.join(',')
      this.model.is_charter = this.model.is_charter || false
      httpRequest(this.model)
        .then(res => {
          this.$notify.success({
            message: 'Route saved successfully'
          })
          this.gotoFarePage()
        })
        .catch(err => {
          this.$notify.error(err.response.data)
        })
    },

    onGetLocations () {
      getLocations()
        .then(res => {
          this.locations = res.data
        })
    },

    saveSection () {
      upsertRouteSection(this.route.id, this.sections)
        .then(res => {
          this.$notify({
            type: 'success',
            message: 'Section updated successfully'
          })
        })
    },

    onRemoveSection (event, item) {
      // remove a section
      this.model.sections = this.model.sections.filter(e => e.key !== item.key)
    },

    gotoFarePage () {
      this.$router.push({ name: 'Fares' })
    }
  }
}
</script>

<style lang="scss" scoped>
.fare__add--edit {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;

  form {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/fare/FareAddEdit.vue